<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 17 18" fill="none">
    <path
      d="M4.5 0C4.99875 0 5.4 0.40125 5.4 0.9V2.4H11.4V0.9C11.4 0.40125 11.8012 0 12.3 0C12.7987 0 13.2 0.40125 13.2 0.9V2.4H14.4C15.7237 2.4 16.8 3.47625 16.8 4.8V15.6C16.8 16.9237 15.7237 18 14.4 18H2.4C1.07625 18 0 16.9237 0 15.6V4.8C0 3.47625 1.07625 2.4 2.4 2.4H3.6V0.9C3.6 0.40125 4.00125 0 4.5 0ZM4.5 4.2H2.4C2.07 4.2 1.8 4.47 1.8 4.8V6.6H15V4.8C15 4.47 14.73 4.2 14.4 4.2H4.5ZM1.8 8.4V15.6C1.8 15.93 2.07 16.2 2.4 16.2H14.4C14.73 16.2 15 15.93 15 15.6V8.4H1.8Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'SessionIcon',
  props: {
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#484848'
    }
  }
};
</script>
